import { AiOutlineWhatsApp } from "react-icons/ai";
import "./jointChat.css";

function jointChat() {
  return (
    <div className="support-group" id="support-wrapper">
      <a
        className="button-0-0-21 buttonizer-head"
        href="https://api.whatsapp.com/send?phone=905010912429"
        rel="noreferrer"
        target="_blank"
      >
        <AiOutlineWhatsApp className="fab fa-whatsapp support-icon" />
        <div className="buttonizer-label label-0-0-24">Need Support?</div>
      </a>
    </div>
  );
}

export default jointChat;
